import React, { useEffect, useState } from 'react';
import { useWeddingDay } from '../state/useWeddingDay';

const e = React.createElement;

// Read off the payload the page already loaded, so the band costs no request.
const remainingFrom = (locksAt) => {
  const at = locksAt ? new Date(locksAt).getTime() : 0;
  if (!at || Number.isNaN(at)) return 0;
  return Math.max(0, at - Date.now());
};

/**
 * Days alone while there are days: a header is glanced at, and a number that
 * changes every second there reads as noise. Inside the last day it counts
 * down properly, which is when the seconds are the point.
 */
const format = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const days = Math.floor(total / 86400);
  if (days > 0) return `${days}d`;

  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const pad = (n) => String(n).padStart(2, '0');
  if (hours > 0) return `${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
  return `${pad(minutes)}m ${pad(seconds)}s`;
};

/**
 * How long the couple has left, shown where the creative preferences form
 * shows it. The form closes thirty days before the first event, because the
 * crew is planned off whatever it holds by then.
 */
const Deadline = () => {
  const { locksAt, closed } = useWeddingDay();
  const [remaining, setRemaining] = useState(() => remainingFrom(locksAt));

  useEffect(() => {
    if (!locksAt || remainingFrom(locksAt) <= 0) {
      setRemaining(0);
      return undefined;
    }
    // Reads the clock each tick rather than decrementing, so a backgrounded
    // tab catches up instead of drifting.
    const timer = setInterval(() => {
      const left = remainingFrom(locksAt);
      setRemaining(left);
      if (left <= 0) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
  }, [locksAt]);

  // A closed form says so in its own banner, so the header stays quiet.
  if (!locksAt || closed || remaining <= 0) return null;

  return e('span', { className: 'wd-deadline' }, [
    'Closes in ',
    e('strong', { className: 'wd-deadline-time', key: 't' }, format(remaining)),
  ]);
};

export default Deadline;
